import React from "react";
import { ExportCSV } from "./ExportCSV";

function GetUsluga(usluga) {
  switch (usluga.type) {
    case "2":
      return (
        "Изменения"
      );
      break;
    case "3":
      return "Первичка"
      break;
    case "4":
      return "Ликвидация"
      break;
    case "5":
      return "Подача необходимых документов в регистрирующий орган и получение документов, подтверждающих гос. регистрацию уведомления о составлении промежуточного баланса, ликвидационного баланса, а также документов, подтверждающих регистрацию прекращения деятельности Общества";
      break;
    case "6":
      return "Содействие в получении справок о состоянии расчетов Общества с налоговой инспекцией, пенсионным фондом и фондом социального страхования";
      break;
    case "7":
      return "ЭЦП";
      break;
    case "8":
      return "Адрес";
      break;
    case "9":
      return "Представительство в банках и гос. органах";
      break;
    case "10":
      return "Консультация";
      break;
    case "11":
      return "Пробирка";
      break;
    case "12":
      return (
        "Подача в налоговую"
      );
      break;
    case "13":
      return usluga.other;
      break;
    default:
      return "";
  }
}

function checkDateEntrance(date, from, to) {
  var periods = [from, to];
  if (date >= (periods[0]) && date <= (periods[1]))
    return true
  else
    return false
}

export const CardsExporter = ({isFilter = false,from, to, cards }) => {
    let filteredData = cards
    let isError = false
    let errorMessage = ''
    if ((!from || !to) && isFilter){
        isError = true
        errorMessage = 'Диапазон не введен'
    }
  if (from && to && isFilter) {
    let fromDate = [from.slice(6, 10), from.slice(3,5), from.slice(0, 2)].join('-')
    fromDate = new Date(fromDate)
    let toDate = [to.slice(6, 10), to.slice(3, 5), to.slice(0, 2)].join('-')
    toDate = new Date(toDate)
    if (fromDate > toDate) {
        isError = true
        errorMessage = 'Некорректно введен диапазон'
    }
    const filterLogic = (elem) => {
      let date = [elem.date.slice(6, 10), elem.date.slice(3, 5), elem.date.slice(0, 2)].join('-')
      date = new Date(date)
      return checkDateEntrance(date, fromDate, toDate)
    }
    filteredData = cards.filter(filterLogic);
  }
  const data = filteredData.map((elem, index) => {
    let isPervich =['']
    isPervich = elem.uslugi.filter(usluga => usluga.type === '3')
    return {
      Дата: elem.date === "" ? "-" : elem.date,
      Наименование: ((isPervich.length !== 0 && isPervich[0]?.name !== '' && isPervich[0]?.name !== null) ? isPervich[0]?.name :
        (elem.formData.clientType.type === "ф.л." ? elem.formData.clientType.fio : elem.formData.clientType.type === "ю.л." ? elem.formData.clientType.name : '-') === '-'
          ? "-"
          : elem.formData.clientType.name === ""
          ? elem.formData.clientType.fio
          : (elem.formData.clientType.ofp === 'Иное' ? elem.formData.clientType.shortofp : elem.formData.clientType.ofp)+ (elem.formData.clientType.ofp === 'ИП' ? " " + elem.formData.clientType.name: ' «'+elem.formData.clientType.name+"»")),
      ИНН: elem.inn === "" ? "-" : elem.inn,
      Телефон: elem.formData.phone ? elem.formData.phone : '-',
      Почта: elem.formData.email ? elem.formData.email : '-',
      Услуги:
        elem.uslugi.map((usluga) => {
          return GetUsluga(usluga);
        }).length === 1
          ? "-"
          : elem.uslugi
              .map((usluga) => {
                return GetUsluga(usluga);
              })
              .join(", ").slice(0, -2),
      Сумма: elem.formData.totalPrice ? elem.formData.totalPrice : '-',
      Юрист: elem.urist === "" ? "-" : elem.urist,
    };
  });
  return (
      <div>
          {isError ? <p>{errorMessage}</p> : <p>Найдено {filteredData.length} карточек</p>}
          {isError ? <a  className="waves-effect waves-light btn-small disabled">Выгрузить</a> :<ExportCSV csvData={data} fileName="myfile" />}
      </div>
  )
};
